import React, { useState, useEffect } from 'react';
import { FaUser, FaEnvelope, FaExclamationTriangle } from 'react-icons/fa';
import './UserSettings.css';
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';
import { IoPaperPlaneOutline } from "react-icons/io5";
import { MdCancel } from "react-icons/md";
import { GiUpgrade } from 'react-icons/gi';
import { Button } from "flowbite-react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const UserSettings = () => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const { user, logout } = useAuth0();
  const userId = user.sub
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get('https://pressconnect-backend-99be5a99f8df.herokuapp.com/api/user-settings', {
          params: {
            sub: user.sub
          }
        });
        console.log('The response:', response);
        setUserData(response.data);
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchUserData();
    
  }, []);
  const handleDeleteAccount = async (e, id) => {
    try {
      e.preventDefault();
      console.log('User:', id);
      // Call the server endpoint to delete the user
      const response = await axios.post('https://pressconnect-backend-99be5a99f8df.herokuapp.com/cancel-subscription', { id: userData._id });
      console.log('The response:', response);
      if (response.status === 200) {
        console.log('User deleted successfully', response);
        setUserData(response.data.user);
        toast.success('Subscription cancelled.')
      } else {
        console.error('Failed to delete user:', response);
      }
      setIsDeleteModalOpen(false)``
    } catch (error) {
      console.error('Error deleting user:', error);
    } 
  };

  const handleUpgrade = async() => {
    console.log('User:', user);
    const id = userData._id
    // const clientReferenceId = user.sub.split('|')[1];
    window.location.href = `https://buy.stripe.com/14k5o69LQaoOdmE5km?client_reference_id=${encodeURIComponent(id)}`;
};

  return (
    <div className="user-settings">
      <ToastContainer />
      <form>
        <div className="form-group">
          <label className="flex items-center space-x-1" htmlFor="email">
            <FaUser className="text-gray-500" /> 
            <span>Full Name</span>
          </label>
          <input
            className='mb-3'
            disabled
            type="text"
            id="fullName"
            value={user.name}
            readOnly
          />
        </div>
        <div className="form-group mb-2">
            <label className="flex items-center space-x-1" htmlFor="email">
              <FaEnvelope className="text-gray-500" /> 
              <span>Email Address</span>
            </label>
            <input
              disabled
              type="email"
              id="email"
              value={user.email}
              readOnly
            />
        </div>
        <div className="form-group">
            <label className="flex items-center space-x-1" htmlFor="email">
              <IoPaperPlaneOutline className="text-gray-500" /> 
              <span>Plan</span>
            </label>
            {
              userData ? 
              <input
                className='bg-white'
                disabled
                type="plan"
                id="plan"
                value={userData.isPro ? 'Pro' : 'Trial'}
                readOnly
            /> : 'Loading...'
            }
        </div>
      </form>
      { userData ? userData.isPro ? 
              <div className="danger-zone">
              <h2>Danger Zone</h2>
              <button 
                className="btn btn-danger"
                onClick={() => setIsDeleteModalOpen(true)}
              >
                Cancel Subscription
              </button>
            </div>
          :         
      <button
          onClick={handleUpgrade}
          type="button"
          className="relative mt-2 inline-flex items-center justify-center p-0.5 mb-2 me-2 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-cyan-500 to-blue-500 group-hover:from-cyan-500 group-hover:to-blue-500 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-cyan-200 dark:focus:ring-cyan-800 ml-auto"
        >
          <span className="flex relative px-5 py-2.5 bg-gradient-to-r from-red-200 via-red-300 to-yellow-200 hover:bg-gradient-to-bl transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
            <GiUpgrade className="mr-1" />
            Upgrade Plan
          </span>
        </button> : 'Loading...'
      }
      {isDeleteModalOpen && (
        <div className="modal-overlay">
          <div className="modal">
            <h2>
              <FaExclamationTriangle /> Confirm Account Deletion
            </h2>
            <p>Are you sure you want to delete your account? This action cannot be undone.</p>
            <div className="modal-actions">
              <button className="btn btn-secondary" onClick={() => setIsDeleteModalOpen(false)}>Cancel</button>
              <button className="btn btn-danger" onClick={(e)  =>handleDeleteAccount(e, userData._id)}>Delete Account</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserSettings;